document.addEventListener("DOMContentLoaded", function () {

    const container = document.getElementById('anchor__links');
    const headers = document.querySelectorAll('.article__main h2');

    if (container) {

        if (headers.length === 0) {
            container.style.display = 'none';  // Hide the container if there are no h2 headers)
            if (container.parentElement.classList.contains("article__sidebar") && !container.parentElement.querySelector(".article__sidebar__nav")) {
                container.parentElement.style.display = 'none';  // Hide the sidebar if there are no h2 headers
            }
        }

        if (headers.length != 0) {
            container.style.display = 'block';  // Hide the container if there are no h2 headers
        }

        headers.forEach((header, index) => {

            if (header.textContent.trim() !== "") {
                if (!header.id) {
                    header.id = `section-${index}`;  // Ensure each h2 has a unique ID
                }

                const linkContainer = document.createElement('div');
                linkContainer.classList.add("nav-tree__item");

                const link = document.createElement('a');
                link.href = `#${header.id}`;
                link.textContent = header.textContent;

                const linkIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                linkIcon.setAttribute("class", "icon__svg icon__arrow-dims");
                linkIcon.innerHTML = `<use xlink:href="/static/icons-20260602.svg#arrow"></use>`;

                const linkButton = document.createElement('div');
                linkButton.classList.add("nav-tree__btn");
                // linkButton.classList.add("button-bare");
                linkButton.appendChild(linkIcon);

                linkContainer.appendChild(link);
                linkContainer.appendChild(linkButton);

                container.appendChild(linkContainer);
            }
        });

    }

});
